import { render } from "./BulkReceipts.vue?vue&type=template&id=06376889&scoped=true"
import script from "./BulkReceipts.vue?vue&type=script&lang=js"
export * from "./BulkReceipts.vue?vue&type=script&lang=js"

import "./BulkReceipts.vue?vue&type=style&index=0&id=06376889&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06376889"]])

export default __exports__